import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { take } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class SideNavBarVisibilityService {

  public hideOnMobile: boolean;
  public hideSideNav: boolean;
  public messageSource = new BehaviorSubject(JSON.stringify(null));
  currentMessage: Observable<string> = this.messageSource.asObservable();

  constructor() {
    this.hideOnMobile = false;
    this.hideSideNav = false;
  }

  changeMessage(message: string) {
    this.messageSource.next(message)
  }

  getMessage() {
    take(1);
    return this.currentMessage;
  }
}
